<!-- @migration-task Error while migrating Svelte code: `<form>` cannot be a descendant of `<form>`. The browser will 'repair' the HTML (by moving, removing, or inserting elements) which breaks Svelte's assumptions about the structure of your components.
https://svelte.dev/e/node_invalid_placement -->
<script lang="ts">
    import { onMount } from "svelte";
    import {
        type IAssetGenerationController,
        QualityLevel,
    } from "../../controller/IAssetGenerationController";
    import { ConfigurationManager } from "../../ConfigurationManager";
    import {
        AssetGenerationBundle,
        AssetGenerationProgress,
    } from "../../model";
    import { fade } from "svelte/transition";
    import jQuery from "jquery";
    import {
        type IBookingController,
        type IGamesController,
    } from "../../controller";
    import { Slot, SLOT_TYPES } from "../../model/Slot";
    import SlotInfoCard from "../fragments/SlotInfoCard.svelte";
    import BootstrapVectorIcon from "../components/BootstrapVectorIcon.svelte";
    
    import {
        DefaultErrorHandler,
        getMessagingService,
        MESSAGE_TYPE,
        type MessagingService,
    } from "../../utility/ContextHelper.svelte";

    import * as bip39 from "@scure/bip39";
    import { wordlist } from "@scure/bip39/wordlists/english";

    import { calculateCardColsForSlotAssetCandidates } from "../../utility/CardUtility.svelte";
    import AssetCandidateCard from "../components/AssetCandidateCard.svelte";
    import { AuthInfo, getAuthInfo } from "../../utility/AccountUtility";
    import { capitalizeFirstLetter } from "../../utility/helper";

    
    // File Upload

    // A file type grouping enum to identify types of files for 3d objects and textures
    enum FILE_TYPE {
        Model3D,
        Picture,
    }



    let fileTypeWhitelist: FILE_TYPE[];

    



    let msgSrvc: MessagingService = getMessagingService();



    // END File upload

    let { params = { id: undefined } }: { params: { id: string } } = $props();
    let id = params.id;

    let assetGenerationController: IAssetGenerationController =
        ConfigurationManager.getInstance().assetGenerationController;
    let gamesController: IGamesController =
        ConfigurationManager.getInstance().gamesController;
    let campaginController: IBookingController =
        ConfigurationManager.getInstance().bookingController;

    let msgService: MessagingService = getMessagingService();

    /**
     * The active inner tab for asset generation/upload selection
     */
    let activeInnerTab: string = "generate";

    /**
     * The currently active wizard page (1-based)
     */
    let activePage: number = 1;

    /**
     * The slot for which we are creating an asset
     */
    let slot: Slot = $state();

    /**
     * The currently active job for asset generation
     */
    let activeJob: AssetGenerationBundle = $state();

    /**
     * A merged list of all jobs from saved and active for display
     */
    let allJobs: Map<string, AssetGenerationProgress> = $state(new Map());


    let exampleBrands: string[] = $state([
        "Starbucks", "iPhone", "AWS"
    ]);

    function addBrand(ev: Event) {
        let text: string = jQuery('#newBrand').val() as string;
        if(text == "") {
            return;
        }
        if(!exampleBrands.includes(text)) {
            exampleBrands.push(text);
            exampleBrands = exampleBrands;
        }
        jQuery('#newBrand').val("");

        ev.preventDefault();
        return false;
    }

    function removeEventHandler(ev: Event) {
        let span = jQuery(this).parent().find("span");
        let br: string = span.text() as string;

        exampleBrands = exampleBrands.filter((v: string) : boolean => {
            return v != br;
        });

        ev.preventDefault();
        return false;
    }

    /**
     * The interval in miliseconds in which we are going to poll for asset generation result status
     */
    const updateStatusDelay = 2000;

    /**
     * The number of card grid columns (see bootstrap) to occupy with one generated asset. This is calculated based on aspect ratio to make them appear nicely
     */
    let cardGridCols: number = 3;




    /**
     * Will update the allJobs map for display
     * @param jobProgress
     */
    function updateAllJobsMap(jobProgress: AssetGenerationBundle) {

        if (!activeJob) {
            activeJob = new AssetGenerationBundle();
        }
        let incomingJobs: Map<string,AssetGenerationProgress> = jobProgress.toMap();

        // Update all jobs
        const updatedJobs = new Map(allJobs);
        for(let key of incomingJobs.keys()) {
            let entry: AssetGenerationProgress = incomingJobs.get(key);
            updatedJobs.set(entry.jobId, entry);
            // TODO when changing status, we want to display success or error, if job is finished
        }
        allJobs = updatedJobs;
        activeJob.subJobs = Array.from(allJobs.values());
    }


    /**
     * Queries the current state of the active job
     */
    function updateStatus() {
        if (!activeJob) {
            return;
        }
        assetGenerationController
            .getGroupStatus(activeJob)
            .then((val: AssetGenerationBundle) => {
                updateAllJobsMap(val);

                if (activeJob.getProgressPercent() < 1) {
                    setTimeout(updateStatus, updateStatusDelay);
                } else {
                    // We are done generating
                    updateAllJobsMap(val);
                    jQuery("#btnAssetGenerate").prop("disabled", false);
                    if (
                        activeJob.subJobs.filter((job: AssetGenerationProgress): boolean => {
                            return !job.assetUrl && !job.error
                        }).length > 0
                    ) {// continue refreshing if any unfinished
                        setTimeout(updateStatus, updateStatusDelay);
                    } else {
                        msgService.BoradcastMessage(
                            "Finished generating assets",
                            MESSAGE_TYPE.SUCCESS,
                        );
                    }
                }
            });
    }

    /**
     * Callback to kick off asset gerneration upon button click
     * @param event
     */
    function generateClicked(event: Event) {
        // activeJob = undefined;
        jQuery(event.target).prop("disabled", true);
        let protoPrompt: string = jQuery("#textprompt").val() as string;
        event.preventDefault();

        if (protoPrompt == "Magic" || protoPrompt == "magic") {
            let exampleBundle: AssetGenerationBundle =
                new AssetGenerationBundle();
            let exampleAsset: AssetGenerationProgress =
                new AssetGenerationProgress();

            exampleAsset.jobId = "1234567";
            exampleAsset.progress = 100;
            exampleAsset.total = 100;
            exampleAsset.assetUrl =
                "http://localhost:8072/asset/e3f0148f-d733-4e97-8acf-b53d264e8f44";

            exampleBundle.subJobs.push(exampleAsset);
            updateAllJobsMap(exampleBundle);
            jQuery(event.target).prop("disabled", false);
            return false;
        }

        // Check for placeholder
        if(protoPrompt.indexOf("[BRAND]") < 0) {
            msgService.BroadCastError("Please make sure your prompt contains the [BRAND] placeholder");
            jQuery(event.target).prop("disabled", false);
            return;
        }

        for(let br of exampleBrands) {
            let prompt: string = protoPrompt.replaceAll("[BRAND]", br);
            console.log("Prompt: " + prompt);
            assetGenerationController
                .generateMultipleImagesFromPrompt(
                    prompt as string,
                    undefined,
                    slot.dimensions,
                    1,
                    QualityLevel.FAST,
                    slot.transparency ?? false,
                )
                .then((val: AssetGenerationBundle) => {
                    updateAllJobsMap(val);
                    setTimeout(updateStatus, updateStatusDelay);
                })
                .catch((err) => {
                    jQuery(event.target).prop("disabled", false);
                });

        }
        return false;
    }


    let storing: boolean = $state(false);
    function storeClicked(event: Event) {
        storing = true;
        event.preventDefault();
        gamesController.storeSlotData(slot).then((v: Slot) => {
            slot = v;
            msgService.BoradcastMessage("Prompt updated.", MESSAGE_TYPE.SUCCESS);
        }).catch(DefaultErrorHandler).finally(() => {
            storing = false;
        });

        return false;
    }

    

    onMount(() => {
        let authInfo: AuthInfo = getAuthInfo();

        gamesController.getSlot(id).then((incomingSlot: Slot) => {
            slot = incomingSlot;

            if (slot.type == SLOT_TYPES.OBJECT_3D) {
                fileTypeWhitelist = [FILE_TYPE.Model3D];
            } else {
                fileTypeWhitelist = [FILE_TYPE.Picture];
            }

            cardGridCols = calculateCardColsForSlotAssetCandidates(slot);
        }).catch(DefaultErrorHandler);

        let mnenomic = bip39.generateMnemonic(wordlist, 128);
        // Use only 3 words from mnenomic
        let mnenomicArr = mnenomic.split(" ");
        mnenomicArr = mnenomicArr.map(capitalizeFirstLetter);
    });

    function keepImageCheckboxClicked(assetId: string) {


        updateAllJobsMap(activeJob);
    }

    /**
     * A callback function for the checkbox in the summary, making any and all items checked
     * @param id
     */
    function itemAllChecked(id: string): boolean {
        return true;
    }
</script>

<div class="container-fluid">
    <div class="d-flex align-items-baseline justify-content-between">
        <!-- Title -->
        <h1 class="h2">Refine Prompt</h1>
    </div>

    <div class="row justify-content-center">
        <div class="col-12">
            <form class="needs-validation" novalidate>


                <div
                >
                    <h2 class="text-center mb-0">Refine Your Prompt</h2>
                    <p class="text-info text-center">
                        Refine your prompt and check it against a list of brands
                    </p>
                    <!-- Card -->

                    <div class="row">
                        <div class="col-12 col-xl-6 ps-0">
                            {#if slot}
                                <SlotInfoCard
                                    horizontal={window.screen.width > 1600}
                                    {slot}
                                ></SlotInfoCard>
                            {/if}
                        </div>

                        <div class="col-12 col-xl-6 pe-0">
                            <div class="card h-100">

                                <div
                                    class="d-flex flex-column h-100"
                                >
                                    <label
                                        class="form-label"
                                        for="textprompt"
                                        >Prompt</label
                                    >
                                    {#if slot}
                                        <textarea
                                            name="prompt"
                                            id="textprompt"
                                            class="form-control w-100 mb-2 fs-3 flex-grow-1"
                                            bind:value={slot.prompt}></textarea
                                        >
                                        <p class="d-inline-flex gap-1">
                                            <button
                                                id="btnAssetGenerate"
                                                class="btn btn-primary align-self-start my-2"
                                                onclick={generateClicked}
                                                >Generate</button
                                            >
                                            <button
                                                id="btnPromptSave"
                                                class="btn btn-primary align-self-start my-2"
                                                onclick={storeClicked}
                                                disabled={storing}
                                                >Save</button
                                            >
                                        </p>
                                    {/if}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row my-4">
                        <h2 class="text-center mb-0">Example Brands</h2>
                        <p class="text-info text-center">
                            List brands to benchmark your prompt with
                        </p>
                        {#each exampleBrands as brand}
                            <div class="col-1 px-2">
                                <span>{brand}</span>&nbsp;
                                <button class="btn bn-link py-1" onclick={removeEventHandler}>
                                    <BootstrapVectorIcon icon="x" class="text-danger" style="height: 1em; width: 1em;"></BootstrapVectorIcon>
                                </button>
                            </div>
                        {/each}
                        <div class="col-1 px-2 d-flex">
                            <input type="text" id="newBrand" class="float-start" />
                            <button class="btn bn-link py-1 float-start" onclick={addBrand}>
                                <BootstrapVectorIcon icon="plus" class="text-success" style="height: 1em; width: 1em;" ></BootstrapVectorIcon>
                            </button>
                        </div>

                    </div>

                    <h2 class="text-center mt-6 mb-0">
                        Example Assets
                    </h2>
                    <p class="text-info text-center mb-6">
                        Your prompts used on your example brands / products
                    </p>
                    {#if allJobs.size > 0}
                        <div class="my-3" in:fade>
                            <div class="row">
                                {#each Array.from(allJobs.values()) as job, index (job)}
                                    <AssetCandidateCard
                                        assetId={job.jobId}
                                        assetUrl={job.assetUrl}
                                        {cardGridCols}
                                        checked={false}
                                        {job}
                                        keepImageCheckboxCallback={keepImageCheckboxClicked}
                                        {slot}
                                    ></AssetCandidateCard>
                                {/each}
                            </div>
                            <!-- / .row -->
                        </div>
                    {/if}
                </div>

            </form>
        </div>
    </div>
    <!-- / .row -->
</div>
<!-- / .container-fluid -->
